import { useEffect, useState } from 'react';
import { CasesGeneralInformationListActions } from './actions';
import { GridColDef, GridPaginationModel } from '@mui/x-data-grid';
import { asyncGetCasesGeneralInformations } from '../../../../../services/cases-general-information.service';
import {
    CasesGeneralInformation,
    CasesGeneralInformationFilter,
} from '../../../../../shared/types/modules/cases-general-information';
import { TableTooltip } from '../../../../components/general/table';
import { useNavigate } from 'react-router-dom';
import DateTimeFormat from '../../../../components/dateTimeFormat';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../redux/store';
import {
    isSupervisor,
    isTrainerOrQuality,
} from '../../../../../shared/types/profiles';

export const useCasesGeneralInformationList = (
    filters?: CasesGeneralInformationFilter
) => {
    const navigate = useNavigate();
    const { logUser } = useSelector((state: RootState) => state.general);
    const { type } = logUser || {};
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState<CasesGeneralInformation[]>([]);
    const [page, setPage] = useState<number>(0);
    const [pageSize, setPageSize] = useState<number>(10);
    const [total, setTotal] = useState<number>(0);
    const [finalFilters, setFinalFilters] =
        useState<CasesGeneralInformationFilter>({});
    const paginator = (model: GridPaginationModel) => {
        if (model.page !== page) {
            setPage(model.page);
        } else if (model.pageSize !== pageSize) {
            setPageSize(model.pageSize);
        }
    };
    const columns: GridColDef<CasesGeneralInformation>[] = [];

    if (!isSupervisor(type) && !isTrainerOrQuality(type)) {
        columns.push({
            field: 'actions',
            headerName: 'Acciones',
            width: 100,
            sortable: false,
            disableColumnMenu: true,
            filterable: false,
            align: 'center',
            headerAlign: 'center',
            renderCell: (row) => (
                <CasesGeneralInformationListActions id={row.id} />
            ),
        });
    }

    columns.push(
        {
            field: 'caseId',
            headerName: 'ID Caso',
            minWidth: 120,
            flex: 0.4,
            renderCell: (row) => <TableTooltip value={row.row.callId || ''} />,
        },
        {
            field: 'document',
            headerName: 'Documento Cuenta',
            minWidth: 120,
            flex: 0.4,
            renderCell: (row) => (
                <TableTooltip value={row.row.account?.document || ''} />
            ),
        },
        {
            field: 'name',
            headerName: 'Nombre de Cuenta',
            minWidth: 150,
            flex: 0.6,
            renderCell: (row) => (
                <TableTooltip
                    value={`${row.row.account?.name} ${row.row.account?.lastName}`}
                />
            ),
        },
        {
            field: 'typification',
            headerName: 'Tipificación',
            minWidth: 120,
            flex: 0.4,
            renderCell: (row) => (
                <TableTooltip value={`${row.row.typification}`} />
            ),
        },
        {
            field: 'createdBy',
            headerName: 'Creado por',
            minWidth: 120,
            flex: 0.4,
            renderCell: (row) => (
                <TableTooltip
                    value={`${row.row.createdBy?.name} ${row.row.createdBy?.surname}`}
                />
            ),
        },
        {
            field: 'created_at',
            headerName: 'Fecha de creación',
            minWidth: 120,
            flex: 0.4,
            renderCell: (row) => <DateTimeFormat dateAt={row.row.created_at} />,
        }
    );

    useEffect(() => {
        setPage(0);
        setFinalFilters(filters || {});
    }, [filters]);

    useEffect(() => {
        setLoading(true);
        asyncGetCasesGeneralInformations(finalFilters, page, pageSize)
            .then((res) => {
                setRows(res.items);
                setTotal(res.length);
            })
            .finally(() => setLoading(false));
    }, [page, pageSize, finalFilters]);

    return {
        navigate,
        columns,
        rows,
        page,
        pageSize,
        paginator,
        loading,
        total,
    };
};
